
import Vue from 'vue'
import Component from 'vue-class-component'
import isArray from 'lodash/isArray'

// @link https://class-component.vuejs.org/guide/props-definition.html
const BtnProps = Vue.extend({
  props: {
    buttonSize: {
      type: [String, Array],
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    externalUrl: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    customColor: {
      type: String,
      default: ''
    },
    marginBottom: {
      type: String,
      default: ''
    },
  },
})

@Component
export default class Btn extends BtnProps {
  data() {
    return {
      link: false,
    }
  }
  // computed
  get buttonClass(): string {
    const type = this.type
    const buttonSize = this.buttonSize
    const marginBottom = this.marginBottom
    const isDisabled = this.isDisabled
    let classModifiers = "";
    if (isDisabled) {
      classModifiers += `c-btn--disabled c-btn--${type}--disabled `
    }
    if (type) {
      classModifiers += ` c-btn--${type}`
    } else {
      classModifiers += " c-btn--primary"
    }
    if (buttonSize && isArray(buttonSize)) {
      for (let size of buttonSize) {
        classModifiers += ` c-btn--${size}`
      }
    } else if (buttonSize) {
      classModifiers += ` c-btn--${buttonSize}`
    }
    if (marginBottom) {
      classModifiers += ` u-margin-bottom-${marginBottom}`
    }
    return "c-btn " + classModifiers;
  }
  get hasSlot(): boolean {
    return !!this.$slots.default;
  }
  // hooks
  created() {
    if (
      (process.env.NODE_ENV !== 'production') &&
      !this.hasSlot &&
      !this.text
    ) {
      console.warn("Your button/CTA has no text!");
    }
  }
  // methods
  onClick(event: Event): void {
    this.$emit('click', event)
  }
}
